import { jsx as _jsx } from "react/jsx-runtime";
import { workspaceKey_AdvisorSandboxEpic } from '../../workspace-configs.js';
import { TS_HorizontalWorkspace } from '@nu-art/ts-workspace-frontend/index';
import { Page_BaseSandbox } from '../Page_BaseSandbox/Page_BaseSandbox.js';
import { Component_NLPRequestHistory } from './NLPRequsetHistory/index.js';
import { Component_NLPRequestTemplate } from './NLPRequestTemplates/index.js';
import { Component_NLPRequestMessageComposer } from './NLPRequestMessageComposer/index.js';
import { ModuleFE_Advisor_Tag, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from '../../../modules/static-modules/healthcare-space.js';
import { ModuleFE_Advisor_AdvisorSnippet, ModuleFE_Advisor_AdvisorWizard } from '../../../modules/static-modules/advisor-context.js';
const EditorKey_SandboxOrderEpic = 'sandbox-order-epic';
export class Page_SandboxNLP extends Page_BaseSandbox {
    static Route = {
        key: 'nlp',
        path: 'nlp',
        Component: this,
        modulesToAwait: [ModuleFE_Advisor_Tag, ModuleFE_Advisor_Variable, ModuleFE_Advisor_Value, ModuleFE_Advisor_AdvisorWizard, ModuleFE_Advisor_AdvisorSnippet]
    };
    workspace = () => ({
        id: EditorKey_SandboxOrderEpic,
        key: workspaceKey_AdvisorSandboxEpic,
        instances: {},
        renderers: {
            horizontalSpace: TS_HorizontalWorkspace,
            templates: () => _jsx(Component_NLPRequestTemplate, {}),
            composer: () => _jsx(Component_NLPRequestMessageComposer, {}),
            history: () => _jsx(Component_NLPRequestHistory, {}),
        }
    });
    getHeader() {
        return 'NLP';
    }
}
//# sourceMappingURL=Page_SandboxNLP.js.map